import { useSelector } from '../actions/types';
import * as selectors from '../selectors';

type Result = {
  fetchingStatus: selectors.FetchingStatus;
  searchTerm: string;
};

export default function useSearchPageData(): Result {
  const searchTerm = useSelector(selectors.searchTerm);

  const fetchingStatus = useSelector(state =>
    selectors.searchPageFetchingStatus(state, searchTerm || '')
  );

  return {
    fetchingStatus,
    searchTerm,
  };
}
